import React, { useMemo } from 'react';
import qrcodegen from 'qrcode-generator';

// Genera el QR completamente en el navegador (sin llamadas a servicios
// externos) a partir de un valor de texto (ej. una URI otpauth://...).
// Evitamos exponer el secreto TOTP a cualquier API de terceros.
export default function QrCode({ value, size = 176 }) {
  const modules = useMemo(() => {
    if (!value) return null;
    try {
      const qr = qrcodegen(0, 'M');
      qr.addData(value);
      qr.make();
      const count = qr.getModuleCount();
      const cells = [];
      for (let r = 0; r < count; r++) {
        for (let c = 0; c < count; c++) {
          if (qr.isDark(r, c)) cells.push([r, c]);
        }
      }
      return { count, cells };
    } catch (_) {
      return null;
    }
  }, [value]);

  if (!modules) return null;
  const { count, cells } = modules;
  const cell = size / count;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ background: '#fff', borderRadius: 8 }}
      role="img"
      aria-label="Código QR de activación"
    >
      {cells.map(([r, c]) => (
        <rect key={`${r}-${c}`} x={c * cell} y={r * cell} width={cell} height={cell} fill="#000" />
      ))}
    </svg>
  );
}
